export default __webpack_public_path__ + "static/media/wrong.7d69de6f.svg";